import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Folderfiles.module.sass";
import Card from "../../../../components/Card";
import Actions from "../../../../components/Actions";
import { getFilesByFolderId, uploadDocumentToFolder, downloadDocument, deleteDocument } from "../../../../services/folderDocument.service";
import { useAuth } from "../../../../contexts/AuthContext";
import { toast } from "react-toastify";
import ModalImportFileToFolder from "../../../../components/ModalImportFileToFolder";

const Folderfiles = ({ className, views, folderId }) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const handleModalClose = () => {
    setModalVisible(false);
  };
  const { getPartnerId } = useAuth();

  useEffect(() => {
    if (folderId) {
      fetchDocuments();
    }
  }, [folderId]);

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      setError(null);
      const docs = await getFilesByFolderId(folderId);
      setDocuments(docs);
    } catch (err) {
      console.error('Erreur lors de la récupération des documents:', err);
      setError('Impossible de récupérer les documents');
    } finally {
      setLoading(false);
    }
  };

  const handleActionSelect = (selectedAction) => {
    console.log("Action sélectionnée :", selectedAction);
    if (selectedAction === "Ajouter un document") {
      setModalVisible(true);
    }
  };

  const handleDownloadDocument = async (document) => {
    try {
      await downloadDocument(document);
    } catch (error) {
      toast.error('Erreur lors du téléchargement du document');
    }
  };

  const handleDeleteDocument = async (documentId) => {
    try {
      await deleteDocument(documentId);
      toast.success('Document supprimé avec succès');
      fetchDocuments(); // Rafraîchir la liste
    } catch (error) {
      toast.error('Erreur lors de la suppression du document');
    }
  };

  const getDocumentActions = (document) => [
    {
      title: "Télécharger",
      action: () => handleDownloadDocument(document)
    },
    {
      title: "Supprimer",
      action: () => handleDeleteDocument(document.id)
    },
  ];

  const headerActions = [
    {
      title: "Ajouter un document",
      action: () => handleActionSelect("Ajouter un document")
    },
  ];

  return (
    <>
      <ModalImportFileToFolder
        visible={modalVisible}
        onClose={handleModalClose}
        folderId={folderId}
        onDocumentUploaded={fetchDocuments}
      />
      <Card
        className={cn(styles.card, className)}
        title="Documents"
        classTitle="title-yellow"
        head={
          <Actions
            className={styles.actions}
            classActionsHead={styles.actionsHead}
            items={headerActions}
          />
        }
      >
        {loading ? (
          <div className={styles.loading}>
            <p>Chargement des documents...</p>
          </div>
        ) : documents.length === 0 ? (
          <div className={styles.empty}>
            <p>Aucun document disponible dans ce dossier.</p>
          </div>
        ) : (
          <div className={styles.popular}>
            <div className={styles.head}>
              <div className={styles.stage} style={{flexGrow: 1}}>Documents</div>
              <div className={styles.stage} style={{width: '60px'}}>Actions</div>
            </div>
            <div className={styles.list}>
              {documents.map((document, index) => (
                <div
                  className={styles.item}
                  key={document.id}
                >
                  <div className={styles.preview}>
                    <img src={'/images/content/contract_logo.png'} alt="Document" />
                  </div>

                  <div className={styles.user} >
                    <div className={styles.title}>
                      {document.title || (document.file.length > 30 ? document.file.substring(0, 30) + '...' : document.file)}
                    </div>
                    <div className={styles.login}>
                      {document.type && <span className={styles.documentType}>{document.type} - </span>}
                      Ajouté le {new Date(document.created).toLocaleDateString('fr-FR')}
                    </div>
                  </div>
                  
                  <div className={styles.details}>
                    <Actions
                      className={styles.documentActions}
                      classActionsHead={styles.actionsHead}
                      items={getDocumentActions(document)}
                    />
                  </div>

                </div>
              ))}
            </div>
          </div>
        )}
      </Card>

    </>
  );
};

export default Folderfiles;
